import {Auth} from 'aws-amplify';

import AdminBase from '@/views/Admin/Layout.vue';

import Dashboard from '@/views/Admin/Dashboard.vue';
import Ceos from '@/views/Admin/Ceos/List.vue';
import Companies from '@/views/Admin/Companies/List.vue';
import Hosts from '@/views/Admin/Hosts/List.vue';
import Settings from '@/views/Admin/Settings/Details.vue';
import Advisors from '@/views/Admin/Advisors/List.vue';
import Guests from '@/views/Admin/Guests/List.vue';

import EventList from '@/views/Admin/Events/List.vue';
import EventDetails from '@/views/Admin/Events/Details.vue';

import GroupList from '@/views/Admin/Groups/List.vue';
import GroupDetails from '@/views/Admin/Groups/Details.vue';

import TrainingList from '@/views/Admin/Trainings/List.vue';
import TrainingDetails from '@/views/Admin/Trainings/Details.vue';

function mustBeAdmin(to: any, from: any, next: any) {
  Auth.currentAuthenticatedUser().then((user) => {
    if (user.signInUserSession.idToken.payload['cognito:groups']) {
      const role = user.signInUserSession.idToken.payload['cognito:groups'][0];
      if (role === 'User') {
        return next({name: 'UserBase'});
      }
    } else {
      return next({name: 'UserBase'});
    }
    return next();
  }).catch(() => {
    return next({name: 'SignIn'});
  });
}

export default [
  {
    path: '/admin',
    name: 'AdminBase',
    component: AdminBase,
    beforeEnter: mustBeAdmin,
    redirect: {name: 'AdminDashboard'},
    children: [
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: Dashboard,
      },
      {
        path: 'events',
        name: 'AdminEvents',
        component: EventList,
      },
      {
        path: 'events/:id',
        name: 'AdminEvent',
        props: true,
        component: EventDetails,
      },
      {
        path: 'hosts',
        name: 'AdminHosts',
        component: Hosts,
      },
      {
        path: 'ceos',
        name: 'AdminCeos',
        component: Ceos,
      },
      {
        path: 'trainings',
        name: 'AdminTrainings',
        component: TrainingList,
      },
      {
        path: 'trainings/:id',
        name: 'AdminTraining',
        props: true,
        component: TrainingDetails,
      },
      {
        path: 'guests',
        name: 'AdminGuests',
        component: Guests,
      },
      {
        path: 'groups',
        name: 'AdminGroups',
        component: GroupList,
      },
      {
        path: 'groups/:id',
        name: 'AdminGroup',
        props: true,
        component: GroupDetails,
      },
      {
        path: 'advisors',
        name: 'AdminAdvisors',
        component: Advisors,
      },
      {
        path: 'companies',
        name: 'AdminCompanies',
        component: Companies,
      },
      {
        path: 'settings',
        name: 'AdminSettings',
        component: Settings,
      },
    ],
  },
];
